import script from "./AlramSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AlramSideBar.vue?vue&type=script&setup=true&lang=js"

import "./AlramSideBar.vue?vue&type=style&index=0&id=3ef94050&lang=scss"

const __exports__ = script;

export default __exports__